










import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { User } from '@/models/user';

@Component
export default class Login extends Vue {
    @State('currentUser') private currentUserState: any;
    @Action('getCurrentUser') private getCurrentUserAction: any;

    private email: string = '';
    private password: string = '';

    private usersRef = firebase.firestore().collection('users');

    private login() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
            (dbUserData) => {
                const userEmail: string = dbUserData.user!!.email!!;
                this.getCurrentUserAction();
                this.$router.replace('/home');
            },
            (err) => {
                alert('Oops: ' + err.message);
            },
        );
    }
}
